import React from 'react';
import PropTypes from 'prop-types';
import {
  TABLE,
  THEAD,
  TBODY,
  TH,
  TR
} from 'zignal-landscape/lib/Table';
import themeable from 'zignal-landscape/lib/themeable';

const Table = ({
  styles,
  headers = [],
  sortable,
  rows = []
}) => {
  return (
    <TABLE>
      <THEAD>
        <TR>
          {
            headers.map( ({ key, label, onClick, Icon }) => (<TH key={key} onClick={onClick}>
              {
                sortable ? (
                  <div className={styles.sortableHeader}>
                    {label}
                    {Icon ? <Icon /> : null}
                  </div>
                ) : (
                  label
                )
              }
            </TH>)
            )}
        </TR>
      </THEAD>
      <TBODY>{rows}</TBODY>
    </TABLE>
  );
};

Table.propTypes = {
  styles: PropTypes.object,
  sortable: PropTypes.bool,
  headers: PropTypes.array,
  rows: PropTypes.array
};

export default themeable(Table);
